import getSectionNodes from '../sections/get-section-nodes';

const sectionExists = (state, id) => {
  const sectionNodes = getSectionNodes(state);
  return sectionNodes.has(id);
};

export default sectionExists;
